/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer">;
    readonly " $refType": "ReplyListContainer_viewer";
};
export type ReplyListContainer_viewer$data = ReplyListContainer_viewer;
export type ReplyListContainer_viewer$key = {
    readonly " $data"?: ReplyListContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'c925ce86e306454cacb63a9508d99eb1';
export default node;
